export const GET_SENTENCES = 'GET_SENTENCES';
export const SET_SENTENCES = 'SET_SENTENCES';
export const GET_MODE = 'GET_MODE';
export const SET_MODE = 'SET_MODE';
export const GET_VISIBILITY = 'SET_VISIBILITY';
export const SET_VISIBILITY = 'SET_VISIBILITY';
export const SET_ID = 'SET_ID';
export const SET_AUTHOR = 'SET_AUTHOR';